<template>
  <div>
    <nav class="menu">
      <router-link to="/home" class="nav-item">
        <div>
          <VsxIcon iconName="Home" :size="25" :color="color" type="linear" />
        </div>
        <span>{{ $t('menuBar.home') }}</span>
      </router-link>
      
      <router-link to="/wallet-user" class="nav-item">
        <div>
          <VsxIcon iconName="EmptyWalletChange" :size="25" :color="color" type="linear" />
        </div>
        <span>{{ $t('menuBar.wallet') }}</span>
      </router-link>

 

      <div class="nav-item active">
          <span v-if="activeMenu" class="ShowChildItemNav">
            <router-link :to="{ name: 'ContactPage' }" @click="activeMenu = false" aria-label="تماس با ما" title="تماس با ما" style="padding-top: 13px;" class="ChildShowChildItemNav2">
                <VsxIcon iconName="Call" :size="25" :color="color" type="linear" />
            </router-link>

            <router-link :to="{ name: 'AboutPage' }" @click="activeMenu = false" aria-label="درباره ما" title="درباره ما" style="padding-top: 12px;" class="ChildShowChildItemNav">
              <span >
                <VsxIcon iconName="Book" :size="25" :color="color" type="linear" />
              </span>
            </router-link>

            <router-link :to="{ name: 'FaqPage' }" @click="activeMenu = false" aria-label="پرسش‌های متداول" title="پرسش‌های متداول">
              <span style="padding-top: 12px;" class="ChildShowChildItemNav">
                <VsxIcon iconName="MessageQuestion" :size="25" :color="color" type="linear" />
              </span>    
            </router-link>
          
            <router-link :to="{ name: 'JourneyPage' }" @click="activeMenu = false" aria-label="مسیر داده‌پردازان" title="مسیر داده‌پردازان">
              <span style="padding-top: 14px;" class="ChildShowChildItemNav1">
                <VsxIcon iconName="Security" :size="25" :color="color" type="linear" />
              </span>
            </router-link>
          </span>

          <span class="text"></span>
      </div>


      <router-link to="/profile" class="nav-item">
          <div>
            <VsxIcon iconName="UserTick" :size="25" :color="color" type="linear" />
          </div>
          <span>{{ $t('menuBar.profile') }}</span>
      </router-link>
      


      <router-link to="/investment" class="nav-item">
          <div>
            <VsxIcon iconName="DollarSquare" :size="25" :color="color" type="linear" />
          </div>
          <span>{{ $t('menuBar.investment') }}</span>
      </router-link>

      <div @click="activeMenuBox" style="cursor: pointer;" class="indicator">

        <div v-if="color == '#2E1977'" class="divShowImage"></div>
        <div v-if="color == '#BB86FC'" class="divShowImage1"></div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "menuBar.vue",
  data() {
    return {
      isOver: false,
      activeMenu: false,
      color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',
      activeIndex: 0,
    };
  },
  methods: {
    activeMenuBox(){
      this.activeMenu = !this.activeMenu
    },
    handleMouseOver() {
      this.isOver = true;
    },
    handleMouseLeave() {
      this.isOver = false;
    },
    setActive(index) {
      this.activeIndex = index;
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if( savedTheme == "light"){
        this.color = '#2E1977'
      }else{
        this.color = '#BB86FC'
      }
    },
    handleClickOutside(event) {
      const menu = this.$el.querySelector('.ShowChildItemNav');
      const indicator = this.$el.querySelector('.indicator');
      if (menu && !menu.contains(event.target) && !indicator.contains(event.target) && this.activeMenu) {
        this.activeMenu = false;
      }
    }
  },
  mounted(){
    setInterval(() => {
      this.loadTheme()
    }, 100);
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped>

</style>
